import React from 'react';

export interface IProps extends React.PropsWithChildren {}

const ClickDialogSubTitle: React.FC<IProps> = React.memo(({ children }) => {
  return <span className="text-sm text-gray-600">{children}</span>;
});

ClickDialogSubTitle.displayName = 'ClickDialogSubTitle';

export default ClickDialogSubTitle;
